import Image from "next/image";

import { IconStar } from "@/components/icons";
import Marquee from "@/components/magicui/marquee";
import { cn } from "@/lib/utils";

const TestimonialCard = ({ rating, quote, name }: { rating: number; quote: string; name: string }) => {
  return (
    <div className="flex flex-col bg-white rounded-[20px] px-10 py-6 border border-ash-200 w-[390px]">
      <div className="flex flex-col items-center justify-between">
        <div className="flex flex-col items-center justify-center gap-2">
          <Image
            src="/quote-mark.png"
            alt="quotation-mark"
            className="shrink-0 mb-2 w-auto h-auto"
            width={24}
            height={24}
          />
          <p className="text-center mb-4 font-semibold whitespace-normal wrap-break-word">{quote}</p>
        </div>
      </div>
      <div className="mt-auto">
        <div className="text-sm">
          {name} <span className="text-ash-800/75">({rating})</span>
        </div>
        <div
          className="flex items-center gap-0.5 text-honey-400"
          role="group"
          aria-label={`Rating: ${rating} out of 5 stars`}
        >
          {[...Array(Math.round(rating))].map((_, i) => (
            <IconStar key={i} className="w-4 h-4 -ml-0.5 aspect-square" />
          ))}
        </div>
      </div>
    </div>
  );
};

const testimonials = [
  {
    rating: 5.0,
    quote:
      "Got a Call Today for the pool fence purely from SEO which has basically never happened before. Site is working!",
    name: "Hoyt C.",
  },
  {
    rating: 5.0,
    quote: "Best website company I've ever used hands down. Call them and I promise you won't regret it!",
    name: "Brian G.",
  },
  {
    rating: 5.0,
    quote:
      "I got my first lead request from the website today!! Holy S**t that was fast and I'm scrambling to make this happen.",
    name: "Christine L.",
  },
  {
    rating: 5.0,
    quote:
      "Also, I really like the first post and how it made auto hashtags and made great copy from my single sentence. Very nice",
    name: "Kenny R.",
  },
  {
    rating: 5.0,
    quote: "I have to say you guys completely blew the other site out of the water; I'm very impressed!",
    name: "Alex B.",
  },
  {
    rating: 5.0,
    quote: "smoothest onboarding i've ever been through",
    name: "Aziz A.",
  },
];

const TestimonialMarquee = ({ className }: { className?: string }) => {
  return (
    <section className={cn("w-full bg-ash-100", className)}>
      <div className="w-full container">
        <h2 className="text-2xl font-semibold mb-4">Real Stories From Other Service Business Owners</h2>

        <div className="relative">
          <Marquee className="[--duration:80s] [--gap:1.5rem] whitespace-nowrap" repeat={6}>
            {testimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.name} {...testimonial} />
            ))}
          </Marquee>
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: "linear-gradient(90deg, #f9fafb 0%, transparent 20%, transparent 80%, #f9fafb 100%)",
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default TestimonialMarquee;
